import React from 'react';
import classNames from 'classnames/bind';

import styles from './RightColumnWrapper.css';

const cx = classNames.bind(styles);

class RightColumnWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openRightColumn: props.openRightColumn,
    };
  }

  static defaultProps = {
    isWhiteBackground: false,
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.openRightColumn !== nextProps.openRightColumn) {
      // delay tampilan supaya gak scroll ke bawah sampai animasi geser kiri selesai
      if (nextProps.openRightColumn) {
        setTimeout(() => {
          this.setState({ openRightColumn: nextProps.openRightColumn });
        }, 600);
      } else {
        this.setState({ openRightColumn: nextProps.openRightColumn });
      }
    }
  }

  render() {
    const { openRightColumn } = this.state;
    const { menuName, isWiderLeft, isWhiteBackground } = this.props;
    const classSlider = openRightColumn
      ? isWiderLeft
        ? 'col-md-5 col-lg-5 visible-md visible-lg visible-sm'
        : 'col-md-6 col-lg-6 visible-md visible-lg visible-sm'
      : `col-md-12 col-lg-12`;
    const wrapperlClassNames = cx({
      wrapper: !isWhiteBackground,
      'wrapper-white': isWhiteBackground,
    });

    // ini buat mengatasi issue redux-form
    // https://github.com/erikras/redux-form/issues/2971
    // dimana kalo redux form component di reset dia gak bakal ngerun validasi
    // karena bugnya divalidasi library redux form
    // jadi kita destroy component ketika bagian ini ke-hide
    // dan kita mount ulang component ketika show
    return (
      <div
        id="mk-col-right"
        className={`${wrapperlClassNames} ${classSlider} ${menuName}`}
      >
        {openRightColumn && this.props.children}
      </div>
    );
  }
}

export default RightColumnWrapper;
